import React, { Component } from "react";
import { Button, Icon} from "semantic-ui-react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import moment from 'moment';
import './styles.scss';
import {
    getShiftControlList
} from "../../core/actions/shiftControlAction";
import ShiftControlForm from '../../components/ShiftControlForm';
import { exportFileAction } from "../../core/actions/commonAction";
import TableDateCustom from '../../components/ProjectTableDate';
import functionCommon from "../../core/common/function";

class ShiftControl extends Component {
    constructor(props) {
        super(props);
        const regex = /[?&]([^=#]+)=([^&#]*)/g;
        const url = window.location;
        let  params = {};
        let match;
        while(match = regex.exec(url)) {
            params[match[1]] = match[2];
        }
        const _currentMonth = (params['month'] && params['month'].length === 2) ? params['month'] : moment().format('MM');
        const _currentYear = (params['year'] && params['year'].length === 4) ? params['year'] : moment().format('YYYY');
        const _searchBy = (params['searchBy'] && (params['searchBy'] === 'date' || params['searchBy'] === 'project')) ? params['searchBy'] : 'date';
        const _projectId = params['projectId'] ? params['projectId'] : '';
        this.state = {
            currentYear: _currentYear,
            currentMonth:   _currentMonth,
            totalRecordYear: _currentYear,
            totalRecordMonth: _currentMonth,
            searchBy: _searchBy,
            projectId: _projectId,
            paramList: {
                month: _currentMonth,
                year: _currentYear,
                sortBy: "lastName-ASC",
            },
            tableProjectStructure: [
                {
                    label: 'labels.id',
                    type: 'id',
                    fixed: 'left',
                    width: 50,
                    className: 'shift-control-no'
                },
                {
                    label: 'labels.fullname',
                    type: 'employeeName',
                    isClass: 'shift-control-name',
                    fixed: "left",
                    width: 200
                }
            ],
           
            data: [],
            dataBusinessTime: {},
            errorCode: "",
            exportDisabled: false,
            open: false,
            searching: true,
            loading: true
        }
    }

    componentWillMount() {
        // Call API position-list, show list position
        this.props.getShiftControlList(this.state.paramList);
    }

    componentWillReceiveProps(nextProps) {
        this.clearTableProjectStructure();
        let data = nextProps.shiftControlReducer.dataShiftControl;
        let date = functionCommon.dateInMonth(this.state.currentMonth, this.state.currentYear);
        date.forEach(item => {
            this.setState(prevState => ({
                tableProjectStructure: prevState.tableProjectStructure.concat(
                    {
                        label: item.dateConvert,
                        type: "shift",
                        isClass: item.isSunOrSa ? 'sun-sat-class' : '',
                        isDate: true,
                        subType: "shiftDate",
                        isValueInArray: true,
                        checkValue: item.date,
                        day: item.day,
                        width: 80
                    }
                )
            }));
        });

        // No data
        if (!data || (data && !data[0])) {
            this.setState({
                errorCode: "018",
                exportDisabled: true,
                searching: false
            });
            setTimeout(
                function () {
                    this.setState({ errorCode: "" });
                }.bind(this),
                2000
            );

        } else {
            this.setState({
                exportDisabled: false,
                searching: false
            });
        }
        
        
        this.setState({
            data: data,
            loading: false
        });
    }

    // Handle on change selectbox
    changeSelect = evt => {
        const name = evt.target.name;
        const value = evt.target.value;   
        switch (name) {
            case 'year':
                this.setState({
                    currentYear: value
                });
                break;
            case 'month':
                this.setState({
                    currentMonth: value
                });
                break;
              
            default:
                this.setState({
                    projectId: value
                });
                break;
        }
    }

    //clear table structure
    clearTableProjectStructure = () => {
        this.setState({
            tableProjectStructure: [
                {
                    label: 'labels.id',
                    type: 'id',
                    fixed: 'left',
                    width: 50,
                    isClass: 'shift-control-no'
                },
                {
                    label: 'labels.fullname',
                    type: 'employeeName',
                    isClass: 'shift-control-name',
                    fixed: 'left',
                    width: 200
                },
            ],
        })
    }

    // Event when click btn Search
    async searchData() {
        const year = this.state.currentYear;
        const month = this.state.currentMonth;
        await this.setState({
            paramList: {
                month: month,
                year: year,
                sortBy:  "lastName-ASC",
            },
            searching: true,
            loading: true
        });
        
        return this.props.getShiftControlList(this.state.paramList);
    }
    // Event when click btn Export
    shiftControlExportAction = () => {
        const exportParam = {
            month: this.state.paramList.month,
            year: this.state.paramList.year,
            sortBy: this.state.paramList.sortBy,
        };
        this.props.exportFileAction({
            'urlGetkey': 'OMProject/requestSecretKey',
            'urlDownfile':  'EngineerHourRecord/shiftControlExport'
        }, exportParam)
    }

    render() {
        const { t } = this.props;
        const {currentMonth, currentYear, searchBy, errorCode, projectId, totalRecordMonth, totalRecordYear } = this.state;
        return (
            <div className="shift-control">
                <h2 className="page-heading">
                    <span onClick={() => setTimeout(function() { window.location = '/' }, 500)}>
                        {t("navigation.engineerHourRecord")}
                    </span>
                    /{" "}
                    <span onClick={() => setTimeout(function() { window.location = '/total-record?month=' +  
                    totalRecordMonth + '&year=' + totalRecordYear + '&searchBy=' + searchBy + '&projectId=' + projectId}, 500)}>
                        {t("navigation.totalRecord")}
                    </span>
                    /{" "}
                    <span onClick={() => setTimeout(function() { window.location = '/shift-control' }, 500)}>
                        {t("navigation.shiftControl")}
                    </span>
                </h2>
                <div className="list-actions">
                    <Button
                        primary
                        onClick={() => this.searchData()} disabled={this.state.searching}
                    >
                        <Icon name="search" />
                        {this.state.searching ?  t("button.searching") : t("button.search")}
                    </Button>
                    <Button
                        disabled={this.state.exportDisabled}
                        onClick={e => this.shiftControlExportAction()}
                    >
                        <Icon name="file excel outline" />
                        {t("button.export")}
                    </Button>
                </div>
                <ShiftControlForm
                    currentValueMonth={currentMonth}
                    currentValueYear={currentYear}
                    changeSelect={input => this.changeSelect(input)}
                />
                {errorCode ? (
                    <div className="error-message list-error-message">
                        {t("message." + errorCode)}
                    </div>
                ) : (
                        ""
                    )}
                <div className="table-responsive">
                    <TableDateCustom
                        tableStructure={this.state.tableProjectStructure}
                        dataList={this.state.data}
                        onRowClick={(val) => this.onRowClick(val)}
                        defaultSort={this.state.paramList.sortBy}
                        unSelectRow={this.state.unSelectRow}
                        isTotal={false}
                        totalAllProject={this.state.totalAllProject}
                        maxHeight="500"
                        width="1270"
                        loading={this.state.loading}
                    />
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => ({
    ...state
});

const mapDispatchToProps = dispatch => ({
    getShiftControlList: opt => dispatch(getShiftControlList(opt)),
    exportFileAction: (url, param) => dispatch(exportFileAction(url, param))
});

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(ShiftControl);
